import React, { useState } from "react";
import { lang } from "../lang";

// Modal for creating daily tasks
function DailyTaskModal({ isOpen, onClose, onSave }) {
  const [name, setName] = useState("");
  const [duration, setDuration] = useState(900); // Default to 15 minutes
  const [daysOfWeek, setDaysOfWeek] = useState({
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false,
    Sun: false,
  });

  const handleDayToggle = (day) => {
    setDaysOfWeek((prev) => ({ ...prev, [day]: !prev[day] }));
  };

  const handleSubmit = () => {
    if (!name.trim()) {
      alert("Task name is required");
      return;
    }
    const selectedDays = Object.keys(daysOfWeek).filter(
      (day) => daysOfWeek[day]
    );
    if (selectedDays.length === 0) {
      alert("Select at least one day");
      return;
    }
    onSave({
      name,
      duration,
      daysOfWeek: selectedDays,
      streak: 0,
      lastCompleted: null,
      isActiveToday: false,
    });
    setName("");
    setDuration(900);
    setDaysOfWeek({
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      Sun: false,
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div className="modal-content">
        <h2>Add Daily Task</h2>
        <label>
          Task Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Practice React.js"
            style={{ width: "100%", margin: "10px 0" }}
          />
        </label>
        <label>
          Duration:
          <select
            value={duration}
            onChange={(e) => setDuration(parseInt(e.target.value))}
            style={{ width: "100%", margin: "10px 0" }}
          >
            <option value={900}>15 Minutes</option>
            <option value={1200}>20 Minutes</option>
            <option value={1800}>30 Minutes</option>
          </select>
        </label>
        <div style={{ margin: "10px 0" }}>
          Days of the Week:
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
              <label key={day} style={{ margin: "5px" }}>
                <input
                  type="checkbox"
                  checked={daysOfWeek[day]}
                  onChange={() => handleDayToggle(day)}
                />
                {day}
              </label>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ marginRight: "10px" }}>
            Cancel
          </button>
          <button onClick={handleSubmit}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default DailyTaskModal;
